module.exports = {
      id: "vikatan-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#vikatan",
      toString: function () {
        return this.url;
      }
    }